import { Button } from "../../core/Button";

import { TRequestButtonProps } from "./RequestButton.type";

export default function RequestButton({
  text,
  type,
  onClick,
  isLoading,
  title,
}: TRequestButtonProps) {
  return (
    <Button
      type={type}
      text={text}
      onClick={onClick}    
      disabled={isLoading} 
      title={title}
      className="bg-gray-100 font-bold text-neutral-400 border-0 hover:bg-emerald-500 hover:bg-opacity-10 hover:text-emerald-500 text-sm"
    />
  );
}
